import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useAppState } from '@components/common/context/app';
import { get } from '../../../../../lib/util/get';
import './Notification.scss';
export default function Notification() {
  var notify = (type, message) => {
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'info':
        toast.info(message);
        break;
      case 'warning':
        toast.warning(message);
        break;
      default:
        toast(message);
    }
  };
  var context = useAppState();
  React.useEffect(() => {
    get(context, 'notifications', []).forEach(n => notify(n.type, n.message));
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ToastContainer, {
    hideProgressBar: true,
    autoClose: false
  }));
}
;